// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ddc7d045","455":"188734d2","977":"df4f1d16"}[chunkId] + ".chunk.js";
};